const svg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.5">
<path opacity="0.9" d="M13.4268 13.4268C11.5342 15.3194 8.46578 15.3194 6.57322 13.4268C4.68067 11.5343 4.68067 8.46584 6.57322 6.57328C8.46578 4.68073 11.5342 4.68073 13.4268 6.57328C15.3193 8.46584 15.3193 11.5343 13.4268 13.4268Z" fill="white"/>
<path opacity="0.9" d="M10 2.44756V1M17.5525 10.0001H19.0001M10 17.5526V19.0001M2.4475 10.0001H0.999939M15.3404 4.65965L16.1364 3.86366M15.3404 15.3405L16.1364 16.1365M4.65958 15.3405L3.86359 16.1365M4.65958 4.65965L3.86359 3.86366" stroke="white" strokeWidth="1.50001" strokeLinecap="round"/>
</g>
</svg>`;

export default svg;